import React from "react"
import "./card css/p-achievement.css"

export default function Pachievement(){
    return(
        <div className="p-achievement-container">
            <h1 className="p-achievement-title">Productivity Achievements</h1>

            <div>
                <p className="p-coming-soon">Coming Soon</p>
            </div>
        </div>
    )
}